/**
 * Preloader - Page Loading Animation
 * Handles the display and hiding of the preloader
 */

(function() {
  'use strict';

  const Preloader = {
    preloader: null,
    minDisplayTime: 500, // Minimum time to show preloader (ms)
    maxDisplayTime: 5000, // Maximum time to show preloader (ms)
    startTime: Date.now(),

    init: function() {
      this.preloader = document.getElementById('pagePreloader');

      if (!this.preloader) {
        return;
      }

      // Handle page load
      if (document.readyState === 'complete') {
        this.hide();
      } else {
        window.addEventListener('load', this.hide.bind(this));
      }

      // Fallback: Force hide after max display time
      setTimeout(() => {
        if (this.preloader && !this.preloader.classList.contains('fade-out')) {
          this.hide();
        }
      }, this.maxDisplayTime);

      // Handle page navigation (for Shopify theme editor)
      document.addEventListener('shopify:section:load', this.hide.bind(this));
    },

    hide: function() {
      if (!this.preloader) {
        return;
      }

      const elapsed = Date.now() - this.startTime;
      const delay = Math.max(0, this.minDisplayTime - elapsed);

      setTimeout(() => {
        this.preloader.classList.add('fade-out');
        document.body.classList.remove('preloader-active');

        // Remove from DOM after animation completes
        setTimeout(() => {
          if (this.preloader && this.preloader.parentNode) {
            this.preloader.parentNode.removeChild(this.preloader);
          }
        }, 500); // Match CSS transition duration
      }, delay);
    }
  };

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      Preloader.init();
    });
  } else {
    Preloader.init();
  }

  // Handle back/forward navigation
  window.addEventListener('pageshow', function(event) {
    if (event.persisted) {
      // Page was restored from cache
      const preloader = document.getElementById('pagePreloader');
      if (preloader) {
        preloader.classList.add('fade-out');
        document.body.classList.remove('preloader-active');
      }
    }
  });

})();
